import { ButtonHTMLAttributes } from "react";
import classNames from "classnames";

const SecondaryButton: React.FunctionComponent<
  ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, className, ...props }) => {
  return (
    <button
      className={classNames(
        "inline-flex items-center px-6 py-3 border border-green-700 text-base font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
